import DateTimeUtils from 'app/_utils/datetime.utils';
import { LiveSession } from './live-session.model';

export class SessionHealthCheckInfo {
  name: string;
  siteId: number;
  site: string;
  dueTime: Date;
  duration?: string;
  colorClass?: 'danger'
  type: 'WAYPOINT' | 'EXPECTED_CHECK_OFF';

  public deserialize(input: LiveSession, type: 'WAYPOINT' | 'EXPECTED_CHECK_OFF'): this {
    this.type = type;
    this.name = input.name;
    this.siteId = input.siteId;
    this.site = input.site;
    this.dueTime = this.calculateDueTime(input);
    return this;
  }

  private calculateDueTime(input: LiveSession): Date {

    if (this.type === 'WAYPOINT') {

      const lastCheckAsMilliseconds = (input.lastUserSessionHealthCheckTime).getTime();
      const intervalAsMilliseconds = input.healthCheckInterval * DateTimeUtils.MILLISECONDS_IN_A_MINUTE;

      const dueDateAsMilliseconds = lastCheckAsMilliseconds + intervalAsMilliseconds;

      return (new Date(dueDateAsMilliseconds));
    } else {
      const dueTime = (new Date(input.expectedCheckOffTime));
      return dueTime;
    }
  }

  public calculateDurationSinceDueTimeAndApplyColorClass(currentTime: Date) {
    const { unit, unitCode, value } = DateTimeUtils.durationAsDaysOrHoursOrMinutesObject(this.dueTime, currentTime);

    this.duration = `${value} ${unit}`;

    // if greater than 15 minutes turn red
    if (value > 15 || unitCode !== 'm') {
      this.colorClass = 'danger';
    }
  }
};
